export default __webpack_public_path__ + "static/media/dataa-logo-color.d9539ee1.svg";